import { gql } from '@apollo/client';

export const CHECK_PICKUP_TRACKING_NUMBER_EXISTS = gql`
  query CheckPickupTrackingNumberExists($trackingNumber: String!) {
    checkPickupTrackingNumberExists(trackingNumber: $trackingNumber)
  }
`;

export interface CheckPickupTrackingNumberExistsResponse {
  checkPickupTrackingNumberExists: boolean;
}
